<template>
<v-row>
  <v-col cols="10" offset="1">
      <v-row class="pt-5" v-if="doc">
            <v-col cols="6" v-for="item in doc.listNames" :key="item.name">
                <results-pages :items="doc.list[item.name]" :title="item.title"></results-pages>
            </v-col>
          </v-row>
  </v-col>
</v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";

import ResultsPages from "@/components/results/structure/ResultsPages";

export default {
  name: "ResultsStructureUser",
  data() {
    return {
      doc: null
    };
  },
  props: {
    uid: String,
    id: String
  },
  watch: {
    uid(val) {
      if (val) {
        this.getExercise();
      }
    },
  },
  mounted() {
    this.getExercise();
  },
  components: {
      ResultsPages
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getExercise() {
      this.doc = null;
      // get a ref to the exercise and listen to changes
      let ref = fb.structureExCollection
        .where("pid", "==", this.id)
        .where("uid", "==", this.uid);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.doc = items[0].doc;
          }
        })
        .catch(function() {});
    },
  },
};
</script>
